import jwtDecode from "jwt-decode";

const DEV_FALLBACK_TOKEN = process.env.REACT_APP_DEV_TOKEN || null;

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token");
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || DEV_FALLBACK_TOKEN;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};
